import { defaultPets } from '../../../types';
import { saveApplication, debounce } from './../../../utilities';
import { DEBOUNCE_TIME } from './../../../constants';
import validate from '../../../validations';


export default {
    refreshOn: ({ pets, havePets }) => [ pets, havePets ],
    init: (fullState, stateManager, internalStateSetter) => {
        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    },
    'Pets.Wrapper.DontHavePets': (_, stateManager) => {
        stateManager.set({ havePets: false, pets: [] })
    },
    'Pets.Wrapper.HavePets': ({ havePets, checked }, stateManager) => {
        const newPet = {...defaultPets}
        stateManager.set({ havePets: true, pets: [newPet] })
    },
    'Pets.Wrapper.PetsList': ({ pets }, stateManager) => {
        stateManager.setPets(pets)
        validate(3000);
    },
    'Pets.Wrapper.AddPet': ({ pets }, stateManager) => {
        const newPet = {...defaultPets}
        stateManager.setPets([...pets, newPet])

        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    },
};
